import React from 'react';

function HRApprovals() {
  return <div>HRApprovals</div>;
}

export default HRApprovals;
